/**
 * Simple Abstraction proxy for sending loga domain object main properties
 */
export class LogaProxy {

  id: number;
  code: string;
  name: string;
  inactive: boolean;

  public static of(id: number, code: string, name: string, inactive: boolean): LogaProxy {
    let p: LogaProxy = new LogaProxy();
    p.id = id;
    p.code = code;
    p.name = name;

    p.inactive = inactive;
    return p;
  }

  public static ofProxu(prx: LogaProxy): LogaProxy {
    let p: LogaProxy = new LogaProxy();
    p.id = prx.id;
    p.code = prx.code;
    p.name = prx.name;
    p.inactive = prx.inactive;
    return p;
  }

}

/**
 * generic response from an action that could be not fully performed
 */
export class ActionDone {
  success: boolean;
  warnings: string[];
}



// WEBPACK FOOTER //
// ./src/model/LogaProxy.ts